export { RowIndicatorDetails, ShrinkProposal } from './PermutatorTypes'
export { PermutatorService } from './PermutatorService'
